import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Start from 23:59:51
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 51
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-3xl md:text-5xl font-serif font-bold text-brand-cream-light" data-id="element-92" data-mp="15bg0e2eg8p2h">
      <div className="flex flex-col items-center" data-id="element-93" data-mp="y0eo5vwqk1yu">
        <span className="bg-brand-darker px-4 py-2 rounded-lg border border-brand-primary/30 shadow-inner" data-id="element-94" data-mp="xz3oa76eved0">
          {format(timeLeft.hours)}
        </span>
        <span className="text-xs font-sans text-brand-primary mt-2 uppercase tracking-widest" data-id="element-95" data-mp="17pybpeve8k01">
          hs
        </span>
      </div>
      <span className="text-brand-primary pb-6" data-id="element-96" data-mp="12tzq1z1g9g3b">:</span>
      <div className="flex flex-col items-center" data-id="element-97" data-mp="f3di07rg3vtb">
        <span className="bg-brand-darker px-4 py-2 rounded-lg border border-brand-primary/30 shadow-inner" data-id="element-98" data-mp="f45edksv9xkn">
          {format(timeLeft.minutes)}
        </span>
        <span className="text-xs font-sans text-brand-primary mt-2 uppercase tracking-widest" data-id="element-99" data-mp="o3s3p88bncxc">
          min
        </span>
      </div>
      <span className="text-brand-primary pb-6" data-id="element-100" data-mp="k3rrzvclxftz">:</span>
      <div className="flex flex-col items-center" data-id="element-101" data-mp="1zh4fc5abozu2">
        <span className="bg-brand-darker px-4 py-2 rounded-lg border border-brand-primary/30 shadow-inner" data-id="element-102" data-mp="1vgkh0ye0jq6c">
          {format(timeLeft.seconds)}
        </span>
        <span className="text-xs font-sans text-brand-primary mt-2 uppercase tracking-widest" data-id="element-103" data-mp="s54zravqjvph">
          seg
        </span>
      </div>
    </div>;
}